import type { OnInit } from '@angular/core';
import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { BrandConfigurationService } from '@core-mkt/services/configuration/brand-configuration.service';
import { EnvService } from '@core-mkt/services/env/env.service';
import { TrustpilotService } from '@core-mkt/services/trustpilot/trustpilot.service';
import { TrustpilotStars } from './trustpilot-stars';

@Component({
  selector: 'trustpilot-stars',
  templateUrl: './trustpilot-stars.component.html',
  standalone: true,
  imports: [CommonModule],
})
export class TrustpilotStarsComponent implements OnInit {
  @Input() data: TrustpilotStars;
  private trustpilotBrandUrl: string;
  trustpilotVerified = false;
  trustpilotTrustScore: number;
  trustpilotNumberOfReviews: number;

  constructor(private bcs: BrandConfigurationService, private env: EnvService, private tps: TrustpilotService) {
    this.trustpilotBrandUrl = `https://www.trustpilot.com/review/${this.bcs.url}`;
  }

  get showStars(): boolean {
    return this.data?.showTrustpilotStars ?? false;
  }

  get cssClasses(): string {
    return this.data?.cssClasses ?? '';
  }

  get isStacked(): boolean {
    return this.data?.useStackedLayout ?? false;
  }

  get trustpilotImage(): string {
    return 'https://xgrit-ecom.imgix.net/ace/trustpilot-star-rating.svg?v=1706889351';
  }

  ngOnInit(): void {
    if (this.showStars && this.env.get.brandConfig.trustpilotId.length > 0) {
      void this.tps.getBrandStarsRating().then((trustPilotRating) => {
        if (!trustPilotRating) return;
        this.trustpilotTrustScore = trustPilotRating.score.trustScore;
        this.trustpilotNumberOfReviews = trustPilotRating.numberOfReviews.total;
        this.checkTrustpilotStars();
      });
    }
  }

  private checkTrustpilotStars(): void {
    if (this.trustpilotNumberOfReviews) {
      this.trustpilotVerified = true;
    }
  }

  openTrustpilot(): void {
    this.tps.openTrustpilot(this.trustpilotBrandUrl);
  }
}
